module.exports = __webpack_public_path__ + "media/images/flags/64/Belize-4077c047caf9b0d7ffafabfb8fdebd6b.png";